import React from "react";

export const CycleDots = ({ completed = 0, total = 4 }) => {
  return (
    <div
      className="flex items-center gap-3"
      data-testid="cycle-counter"
      aria-label={`${completed} de ${total} ciclos concluídos`}
    >
      {Array.from({ length: total }).map((_, i) => {
        const active = i < completed;
        return (
          <span
            key={i}
            data-testid={`cycle-dot-${i}`}
            className={[
              "block rounded-full transition-all duration-500",
              active
                ? "w-2.5 h-2.5 bg-[#D4AF37] shadow-[0_0_0_4px_rgba(212,175,55,0.08)]"
                : "w-2 h-2 bg-stone-900/10",
            ].join(" ")}
          />
        );
      })}
    </div>
  );
};
